import { render, staticRenderFns } from "./paynew.vue?vue&type=template&id=204e3d26&scoped=true&"
import script from "./paynew.vue?vue&type=script&lang=js&"
export * from "./paynew.vue?vue&type=script&lang=js&"
import style0 from "./paynew.vue?vue&type=style&index=0&id=204e3d26&lang=less&scoped=true&"
import style1 from "./paynew.vue?vue&type=style&index=1&lang=less&"
import style2 from "./paynew.vue?vue&type=style&index=2&id=204e3d26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e3d26",
  null
  
)

export default component.exports